import React from "react";

function Chevron(props) {
  return (
    <a href="#0" class="icon-expand-link">
      <svg
        className={props.className}
        height={props.height}
        width={props.width}
        viewBox="0 0 17 18"
      >
        <path
          class="expand"
          fill="#BB6BD9"
          d="M15.2903 7.46396C15.9624 7.46396 16.4665 7.96803 16.4665 8.64014C16.4665 8.97619 16.3405 9.27023 16.1304 9.48026C15.9204 9.6903 15.6264 9.81632 15.2903 9.81631L9.66146 9.81631L9.66146 15.4452C9.66146 15.7812 9.53544 16.0753 9.32541 16.2853C9.11538 16.4953 8.82133 16.6213 8.48528 16.6213C7.81318 16.6213 7.3091 16.1173 7.3091 15.4452L7.3091 9.81631L1.68025 9.81631C1.00815 9.81631 0.504076 9.31224 0.504076 8.64014C0.504076 7.96804 1.00815 7.46396 1.68025 7.46396L7.3091 7.46396L7.3091 1.83511C7.3091 1.16301 7.81318 0.658931 8.48528 0.658931C9.15738 0.65893 9.66146 1.16301 9.66146 1.83511L9.66146 7.46396L15.2903 7.46396Z"
        />

        <path
          class="contract"
          d="M14.5982 2C14.8192 2 15 1.80714 15 1.57143V0.428571C15 0.192857 14.8192 0 14.5982 0H0.401786C0.180804 0 0 0.192857 0 0.428571V1.57143C0 1.80714 0.180804 2 0.401786 2H14.5982Z"
          fill="#BB6BD9"
        />
      </svg>
    </a>
  );
}

export default Chevron;
